<template>
    <page-parts :items="items"/>
</template>

<script>
export default {
    name: "SimpleFullWidthContentWrapper",
    props: ['items'],
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/wrappers/SimpleFullWidthContentWrapper"
</style>